import { useGlobalContext } from '../context'

function BabyWerewolf() {
    const {index,players, openWaitingScreen} = useGlobalContext();
    let currentPlayer = players[index];
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}({currentPlayer.class})</h4>
            <p className='text-center'>You were bitten by the werewolf last turn.I don't know what was your role before, but from now on you will live your life as a cute doggy.
            To win the game, you need to leave the village with your father (master werewolves) and brothers (if any exists) by eliminating all villagers and vampires.</p>
            <div className='d-flex'>
                <img  src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        if (player.class === 'werewolf' || player.class === 'babywerewolf' )
                            return (<button className='btn btn-gradient border' disabled='disabled' key={index}>{player.name}</button>)     
                    })
                }
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default BabyWerewolf;